export const environment = {
    name: 'production',
    production: true,
    apiConfiguration: {
        basePath: '/availability-calendar/api',
        paths: {
            config: '/config',
            calendar: '/calendar',
            translate: '/translate',
            pageKeyData: '/page-key-data/%s',
            validate: '/validate',
            login: '/login',
            logger: '/ui-log'
        }
    },
    analyticsServerPath: 'availability-calendar/analytics'
};
